const GENERAL_SETTINGS = {
  GENERAL_PAGE_HEADER_TITLE: 'تنظیمات عمومی',
  GENERAL_PAGE_HEADER_DESCRIPTION:
    'تنظیمات ویژه وب‌سایت‌ها را از اینجا مدیریت کنید. هر وب‌سایت تنظیمات مستقلی دارد.',
  GENERAL_PAGE_LOGO_UPLOAD_SUBTITLE: 'حداکثر حجم مجاز: 500 کیلوبایت.',
  GENERAL_PAGE_LOGO_UPLOAD_BTN: 'بارگذاری لوگو',
  GENERAL_PAGE_REMOVE_LOGO: ' حذف تصویر',
  GENERAL_PAGE_GUIDE_TOOLTIP:
    '  درصورتی که لوگوی شخصی سازی شده برای وبسایت خود تعریف کنید، آواتار کاربرانی که از وبسایت پیام میدهند با لوگوی تعریف شده‌ی شما در وب اپ نمایش داده میشود.',

  GENERAL_PAGE_SWITCH_1_TITLE: 'مشاهده کلمات تایپ شده',
  GENERAL_PAGE_SWITCH_1_DESC:
    'فعال/غیرفعال کردن نمایش جملات تایپ شده توسط کاربران قبل از ارسال.',
  GENERAL_PAGE_SWITCH_2_TITLE: 'دسترسی ارسال صدا (voice) در ابزارک',
  GENERAL_PAGE_SWITCH_2_DESC:
    'فعال/غیرفعال کردن امکان ارسال صدا (voice) توسط کاربران در ابزارک',
  GENERAL_PAGE_SENDFILE_SWITCH_TITLE: 'دسترسی ارسال فایل در ابزارک',
  GENERAL_PAGE_SENDFILE_SWITCH_DESC:
    'فعال/غیرفعال کردن دسترسی کاربران به ارسال فایل در ابزارک',
  GENERAL_PAGE_SWITCH_3_TITLE: 'مخفی‌سازی عبارت "قدرت گرفته از رایچت"',
  GENERAL_PAGE_SWITCH_3_DESC:
    'فعال/غیرفعال کردن نمایش این عبارت در ابزارک گفتگو.',
  GENERAL_PAGE_SWITCH_4_TITLE: 'ارسال فرم دریافت اطلاعات',
  GENERAL_PAGE_SWITCH_4_DESC: 'تنظیم گرفتن ایمیل یا شماره تلفن کاربران.',
  GENERAL_PAGE_FORM_SETTINGS_BTN: '(تنظیمات)',
  GENERAL_PAGE_FORM_MODAL_SUBMIT_BTN: 'تایید',
  GENERAL_PAGE_FORM_MODAL_CANCEL_BTN: 'انصراف',
};

export default GENERAL_SETTINGS;
